// latest: zhangmyh 2017-6-22 8:02 PM
/* global $ ko u */

let maxlength = 200
let init = function (refer) {
  let vm = {
    maxlength: ko.observable(maxlength),
    reason: ko.observable('')
  }
  let app = u.createApp()
  app.init(vm, $('#reason_refer')[0])
  refer.registerSubmitFunc(() => {
    return vm.reason()
  })
}

let template = require('./index.html')

export default function (option) {
  if (!option) {
    option = {}
  }
  maxlength = option.maxlength || 200
  u.refer({
    isPOPMode: true,
    module: {
      init,
      template
    },
    okId: 'okBtn',
    contentId: 'refer',
    width: '500px',
    title: option.title || '操作确认',
    onOk: option.onOk || function () {},
    onCancel: option.onCancel || function () {}
  })
}



// WEBPACK FOOTER //
// ./src/components/confirmWithReason/index.js